import React from 'react';
import Logo  from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import classes from './sidedrawer.module.css';
import Backdrop from '../../UI/Backdrop/Backdrop';
//import DrawerToggle from '../DrawerToggle/DrawerToggle';
import Auxiliary from '../../../hoc/Auxiliary/Auxiliary';


const sideDrawer = (props) => {
    //open side drawer animation first
    let attachedClasses = [classes.SideDrawer, classes.Close];
    if (props.open) {
        attachedClasses = [classes.SideDrawer, classes.Open];
    }
/* NOT USED after class change to const func         
    if (props.toggleopen) {
                attachedClasses = [classes.DrawerToggle, classes.Open];
            }
            if (props.togglecls) {
                attachedClasses = [classes.DrawerToggle, classes.Close];
            }  */

    return (
        <Auxiliary>
        <Backdrop show={props.open} clicked={props.closed} />
        {/* <DrawerToggle show={props.toggleopen} clicked={props.togglecls} /> */}
        <div className={attachedClasses.join(' ')} onClick={props.closed}> 
            <Logo height="11%" />
            <nav><NavigationItems isAuthenticated={props.isAuth} />  </nav> 
            
        </div>
        </Auxiliary> 
    );
};

export default sideDrawer;